/**
 * @generated SignedSource<<dafe841bf30e33ba37203e09c4553f03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SourceEditPageContainer_Query$variables = {
  slug: string;
};
export type SourceEditPageContainer_QueryVariables = SourceEditPageContainer_Query$variables;
export type SourceEditPageContainer_Query$data = {
  readonly source: {
    readonly " $fragmentSpreads": FragmentRefs<"SourceEditScreenContainer_source">;
  };
};
export type SourceEditPageContainer_QueryResponse = SourceEditPageContainer_Query$data;
export type SourceEditPageContainer_Query = {
  variables: SourceEditPageContainer_QueryVariables;
  response: SourceEditPageContainer_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SourceEditPageContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Source",
        "kind": "LinkedField",
        "name": "source",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SourceEditScreenContainer_source"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SourceEditPageContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Source",
        "kind": "LinkedField",
        "name": "source",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tag",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6a749e709db6536ce6c9b2d15858b8fe",
    "id": null,
    "metadata": {},
    "name": "SourceEditPageContainer_Query",
    "operationKind": "query",
    "text": "query SourceEditPageContainer_Query(\n  $slug: String!\n) {\n  source(slug: $slug) {\n    ...SourceEditScreenContainer_source\n    id\n  }\n}\n\nfragment SourceEditScreenContainer_source on Source {\n  id\n  name\n  tag\n  description\n}\n"
  }
};
})();

(node as any).hash = "3367a5f24a90a97df0db0881975626cd";

export default node;
